import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { currentDomain, currentPath } from '../Index';
import { usePromotionsData } from '../data/PromotionData';
import { useNavigate } from 'react-router-dom';
import useAppPromotionTheme from '../hooks/useAppPromotionTheme';
import PromotionSkeletonDetails from '../data/PromotionSkeletonDetails';

export default function TelegramInvite({ isLightMode }) {
    const isAppPromo = useAppPromotionTheme(isLightMode);
    const { promotionsData, isPromotionDataReady } = usePromotionsData();
    const data = useMemo(
        () =>
            promotionsData.find(
                (promo) => promo.title === 'Telegram Invite KA FGH'
            ),
        [promotionsData]
    );
    const [isMobile, setIsMobile] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 841);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const loggedInState = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(loggedInState);
    }, []);

    // Only redirect when promotion data is ready
    // and the promotion genuinely does not exist.
    useEffect(() => {
        if (!isPromotionDataReady) return;

        if (!data) {
            navigate('/not-found', { replace: true });
        }
    }, [isPromotionDataReady, data, navigate]);

    // Show skeleton while waiting for server time.
    if (!isPromotionDataReady) {
        return <PromotionSkeletonDetails />;
    }

    // Avoid displaying incomplete promotion details
    // while redirecting to the not-found page.
    if (!data) {
        return null;
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Telegram Invite KA FGH</title>
                <link rel="icon" href="/images/fav.webp" sizes="32x32" />
                <meta name="description" content="ddd" />
                <link rel="canonical" href={`${currentDomain}${currentPath}`} />
            </Helmet>
            <div className="promotion-page-main all-page-main-container-min-height">
                <div className="promotion-page-container main-container-global-adjusted-padding">
                    <div className="promotion-tnc-page">
                        <div className="promotion-page-breadcrumb">
                            <a
                                href={
                                    isAppPromo
                                        ? '/promotion/'.replace(
                                              '/promotion',
                                              '/app-promotion'
                                          )
                                        : '/promotion/'
                                }
                            >
                                Promotions
                            </a>
                            / <span>{data.title}</span>
                        </div>
                        <div className="promotion-tnc-banner">
                            <img
                                src={isMobile ? data.imgSrc : data.bannerSrc}
                                alt={`FGH${data.title}`}
                            />
                            <div className="promotion-tnc-content">
                                <div className="promotion-tnc-info">
                                    <div
                                        className={`promotion-indication-message ${data.promotionMessage.class}`}
                                    >
                                        {data.promotionMessage.text}
                                    </div>
                                    <h1>Telegram Invite KA FGH</h1>
                                    <h2>
                                        ₱10 Free Credits for the referrer per
                                        successful invite.
                                    </h2>
                                    <div className="promotion-tnc-period">
                                        <strong> Event Period: </strong>
                                        <span>Starting October 26, 2026</span>
                                    </div>
                                </div>
                                <div className="promotion-tnc-mechanic-content">
                                    <strong>Promo Mechanics</strong>
                                    <ol>
                                        <li>
                                            <p>
                                                Existing verified Telegram
                                                members can invite new FGH
                                                players to join.
                                            </p>
                                        </li>

                                        <li>
                                            <p>
                                                The invited player must be a
                                                first-time Telegram Group member
                                                and complete verification.
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                The referrer receives ₱10 Free
                                                Credits per successful verified
                                                invite.
                                            </p>
                                        </li>
                                        <li>
                                            Maximum of 3 rewarded invites per
                                            referrer per day (₱30 maximum daily
                                            reward).
                                        </li>
                                        <li>
                                            The invited player receives the ₱10
                                            Welcome Offer under TELEGRAM WELCOME OFFER.
                                        </li>
                                    </ol>
                                    <strong>Important Notes </strong>
                                    <ul>
                                        <li>
                                            Referrers must be verified Telegram
                                            Discussion Group members.
                                        </li>
                                        <li>
                                            Each invited player can have only
                                            one referrer.
                                        </li>
                                        <li>
                                            Previously joined members, duplicate
                                            accounts, and self-referrals are not
                                            eligible as new referrals.
                                        </li>
                                        <li>
                                            Subject to FGH promo terms and
                                            conditions.
                                        </li>
                                        <li>
                                            5x rollover (₱50 qualifying turnover).
                                        </li>
                                    </ul>
                                    <div className="promotion-tnc-cta">
                                        <a
                                            className="promotion-cta-btn"
                                            href="https://t.me/fghofficialactivitygroup"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Join Now
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
